import React, { Component } from "react";
import NumberFormat from "react-number-format";

class TotalVotes extends Component {
render() {
	return (
		<>
			<div className="uk-card uk-card-secondary uk-card-small uk-card-body uk-border-rounded uk-text-center uk-margin">
				<div className="uk-light uk-text-large">
					<span>Kami telah menerima</span>
					<span id="totalvotes">
						<NumberFormat
							className="uk-border-rounded"
							style={{ color: "#fff", background: "#424242", padding: "5px 10px", margin: "0 5px" }}
							value={this.props.totalActionCount}
							displayType={"text"}
							thousandSeparator={true}
						/>
					</span>
					<span>undi dengan purata</span>
					<NumberFormat
						className="uk-border-rounded"
						style={{ color: "#fff", background: "#4CAF50", padding: "5px 10px", margin: "0 5px" }}
						value={this.props.totalAverageLikesCount}
						displayType={"text"}
						thousandSeparator={true}
						suffix={" %"}
					/>
					<img src="https://pages.malaysiakini.com/budget2020/img/icon_thumbs_up_line.svg" width="35" alt="suka" />
					<NumberFormat
						className="uk-border-rounded"
						style={{ color: "#fff", background: "#f44336", padding: "5px 10px", margin: "0 5px" }}
						value={this.props.totalAverageDislikesCount}
						displayType={"text"}
						thousandSeparator={true}
						suffix={" %"}
					/>
					<img src="https://pages.malaysiakini.com/budget2020/img/icon_thumbs_down_line.svg" width="35" alt="tidak suka" />
				</div>
			</div>
			<div className="uk-text-center uk-margin-medium-bottom uk-light" style={{ color: "#fff" }}>
				Pengundian ditutup dua minggu selepas pengumuman belanjawan.
			</div>
		</>
		);
	}
}
export default TotalVotes;
